import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import {
    ShFormPasswordComponent,
    ShFormTextInputComponent,
    ShLoadingComponent,
    ShNotificationComponent
} from '@stylehaven/components';
import { LoadingModule } from '../loading/loading.module';
import { AuthenticationRoutingModule } from './authentication-routing.module';
import { LogoutComponent } from './components/logout.component';
import { AuthContainerComponent } from './containers/auth-container/auth-container.component';
import { HandleLoginContainerComponent } from './containers/handle-login/handle-login-container.component';
import { LogoutContainerComponent } from './containers/logout-container/logout-container.component';

@NgModule({
    declarations: [AuthContainerComponent, LogoutComponent, LogoutContainerComponent, HandleLoginContainerComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        LoadingModule,
        AuthenticationRoutingModule,
        TranslateModule.forChild({ extend: true }),
        ShLoadingComponent,
        ShNotificationComponent,
        ShFormTextInputComponent,
        ShFormPasswordComponent
    ]
})
export class AuthenticationModule {}
